// extracted by mini-css-extract-plugin
export var numberInputContainer = "_4s-0";
export var startPickingButton = "_4s-1";